import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';

import { TooltipProvider } from './TooltipProvider';

function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  );
}

const TooltipTrigger = TooltipPrimitive.Trigger;

export { Tooltip, TooltipTrigger };
